import { Capability, CONTENT_ACCESS_GRANT_CAPABILITIES } from '@repo/utils/auth';

/** Who opens the admin notes pages: a reader who writes notes, or one who only shares them. */
export const ADMIN_NOTES_CAPABILITIES: Capability[] = [
  Capability.NotesEdit,
  ...CONTENT_ACCESS_GRANT_CAPABILITIES,
];
